import { KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { StyleSheet, Text, View } from 'react-native';

export default function NotFoundScreen(): ReactElement {
  const { t } = useTranslation(['common']);

  return (
    <View style={styles.fullScreen}>
      <View style={styles.container}>
        <KitText fontSize={32} black bold>
          {t('common:pageNotFound')}
        </KitText>
        <KitText fontSize={18} gray style={styles.description}>
          {t('common:pageNotFoundDescription')}
        </KitText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  fullScreen: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    maxWidth: 620,
    paddingHorizontal: Spacing.l,
    textAlign: 'center',
  },
  description: {
    marginTop: Spacing.m,
  },
});
